import React from 'react';
import { FsComponentSize } from 'globals/types';
import defaultLocales from 'globals/locales/default';
import { TabsProps } from '@material-ui/core';
import FsInnerTab from './FsInnerTab/FsInnerTab';
import { FsTabs, FsTabsContainer } from './FsInnerTabPanel.style-elements';

interface FsInnerTabPanelProps extends Pick<TabsProps, 'variant'> {
  labels: string[];
  size?: FsComponentSize.M | FsComponentSize.L;
  onChange: (
    event: React.ChangeEvent<Record<string, unknown>>,
    newValue: number
  ) => void;
  value: number;
}

const FsInnerTabPanel: React.FC<FsInnerTabPanelProps> = ({
  labels,
  size,
  onChange,
  value,
  variant = 'scrollable',
}) => {
  return (
    <FsTabsContainer>
      <FsTabs
        value={value}
        onChange={onChange}
        aria-label={defaultLocales.tabs}
        variant={variant}
      >
        {labels.map((label: string) => (
          <FsInnerTab
            key={label}
            {...{ label, size: size || FsComponentSize.M }}
            data-test="tab-panel"
          />
        ))}
      </FsTabs>
    </FsTabsContainer>
  );
};

export default FsInnerTabPanel;
